import { PossibleColumnProps, MinimalRow } from "../types";

export function getVisibleSearchFields<TRow extends MinimalRow>(
  visibleColumns: PossibleColumnProps<TRow>[],
  searchFieldMap: Record<string, string>,
): string | undefined {
  const mappedFields = visibleColumns
    .map((col) => (col ? searchFieldMap[col.field] : undefined))
    .filter(Boolean);

  return mappedFields.length ? mappedFields.join(",") : undefined;
}
